export enum TreatmentFormModalContextKeys {
	PRESCRIPTION_STEP_1 = 'prescription_step_1',
	PRESCRIPTION_STEP_2_MEDICAMENT_LIST = 'prescription_step_2_medicament_list',
	PRESCRIPTION_STEP_3 = 'prescription_step_3',
	MEDDI_BABY_REGULAR_EXAMINATION = 'meddi_baby_regular_examination',
	MEDDI_BABY_END_PLAN = 'meddi_baby_end_plan',
	MEDDI_BABY_CREATE_HEALTH_PLAN = 'meddi_baby_create_mothers_health',
}
